import styled from 'styled-components';
import { COLORS } from '../../constants/radar';

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const LoginCard = styled.div`
  background: white;
  padding: 48px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
`;

export const LoginTitle = styled.h1`
  color: ${COLORS.PRIMARY};
  margin-bottom: 16px;
  font-size: 24px;
`;

export const LoginSubtitle = styled.p`
  color: ${COLORS.SECONDARY};
  margin-bottom: 32px;
`;

export const LoginButton = styled.button`
  background-color: ${COLORS.PRIMARY};
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.SECONDARY};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`; 